"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Toolbar_1 = tslib_1.__importDefault(require("@mui/material/Toolbar"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const BulkActionMenu_1 = tslib_1.__importDefault(require("./BulkActionMenu"));
/**
 *
 * @category component
 */
const BulkActionToolbar = (props) => {
    const { selectedCountText, clearButtonProps, resultCountText, bulkActionProps, size = "sm", ...toolbarProps } = props;
    const { label, ...restClearButtonProps } = clearButtonProps;
    const isMultiAction = "items" in bulkActionProps;
    return (react_1.default.createElement(Toolbar_1.default, { disableGutters: true, ...toolbarProps, sx: {
            pl: 2,
            pr: 2,
            borderTopRightRadius: (theme) => theme.spacing(0.5),
            borderTopLeftRadius: (theme) => theme.spacing(0.5),
            bgcolor: (theme) => (0, styles_1.alpha)(theme.palette.secondary.main, 0.08),
            ...((size === "sm" && { height: "64px" }) ||
                (size === "md" && { height: "68.3px" }) ||
                (size === "lg" && { height: "100.52px", alignItems: "flex-start" })),
            ...toolbarProps?.sx,
        } },
        react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "space-between", alignItems: "center", flexWrap: "nowrap", paddingTop: size === "lg" ? 2 : null },
            react_1.default.createElement(Grid_1.default, { item: true, display: "flex", alignItems: "center", gap: 2 },
                isMultiAction && react_1.default.createElement(BulkActionMenu_1.default, { ...bulkActionProps }),
                !isMultiAction && (react_1.default.createElement(Button_1.default, { variant: "contained", ...bulkActionProps }, bulkActionProps?.label)),
                react_1.default.createElement(Typography_1.default, { color: "inherit", variant: "subtitle1", component: "div" }, selectedCountText),
                react_1.default.createElement(Button_1.default, { variant: "text", ...restClearButtonProps }, label)),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Typography_1.default, { color: "inherit", variant: "caption", component: "div" }, resultCountText)))));
};
exports.default = BulkActionToolbar;
